import { FC } from 'react';
import AddGlCode from './AddGlCode';
import AutoDistributeGlCodes from './AutoDistributeGlCodes';
import EditPeriods from './EditPeriods';

interface InvoiceDetailsGlCodesToolbarProps {}

const InvoiceGlCodesToolbar: FC<InvoiceDetailsGlCodesToolbarProps> = () => (
  <div className="flex flex-row gap-2 items-center">
    <>
      <AutoDistributeGlCodes />
      <AddGlCode />
      <EditPeriods />
    </>
  </div>
);
export default InvoiceGlCodesToolbar;
